import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import api from '../config/api';

const LazyPlacePhoto = ({
  tripId,
  photoName,
  fallback,
  width = 80,
  height = 60,
  alt = '',
  usePartnerAuth = false,
  sx = {}
}) => {
  const ref = useRef(null);
  const [src, setSrc] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || !photoName) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setVisible(true);
        observer.disconnect();
      }
    }, { rootMargin: '80px' });
    observer.observe(node);
    return () => observer.disconnect();
  }, [photoName]);

  useEffect(() => {
    if (!visible || !tripId || !photoName) return undefined;
    let cancelled = false;
    api.get('/places/photo', {
      params: { tripId, photoName, maxWidthPx: 400 },
      responseType: 'blob',
      ...(usePartnerAuth ? { usePartnerAuth: true } : {})
    }).then((response) => {
      if (cancelled) return;
      setSrc(URL.createObjectURL(response.data));
    }).catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [visible, tripId, photoName, usePartnerAuth]);

  return (
    <Box ref={ref} sx={{ width, height, borderRadius: 0, overflow: 'hidden', flexShrink: 0, ...sx }}>
      {src ? (
        <Box component="img" src={src} alt={alt} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      ) : fallback}
    </Box>
  );
};

export default LazyPlacePhoto;
